export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_USER_PROFILE = "SET_USER_PROFILE";

export const CLEAR_CURRENT_USER = "CLEAR_CURRENT_USER";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
